import { CookiesConsentValue } from '~/constants/cookies'

// Meta stands for the company Meta (ex Facebook)
const META_PIXEL_ID = '933705904986041'

const { getCookiesConsent } = useCookiesConsent()

export function useMetaPixel() {
  if (import.meta.dev || getCookiesConsent()?.value !== CookiesConsentValue.YES) {
    return
  }

  useHead({
    script: [
      {
        innerHTML: `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${META_PIXEL_ID}');
        fbq('track', 'PageView');
      `,
        type: 'text/javascript'
      }
    ],
    noscript: [
      {
        innerHTML: `
        <img height="1"
             width="1"
             style="display:none" 
             src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1"
        />
      `
      }
    ]
  })
}
